import React from 'react'
const Header = () => {
    return (
        <div>
            <section className='Head'>
                <div className='container flexSB'>
                    <div className='logo'>
                        <h1>ACADIMIA</h1>
                        <span>ONLINE EDUCATION & LEARNING</span>
                    </div>
                    <div className='social'>
                        <i className="fa-brands fa-square-facebook icon"></i>
                        <i className="fa-brands fa-twitter icon"></i>
                        <i className="fa-brands fa-instagram icon"></i>
                        <i className="fa-brands fa-linkedin icon"></i>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Header
